import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, Button, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useTranslate } from "../Translate/TranslateContext";
import { updatePassword } from "../../api/userPassword";
import { buttonPrimaryStyles } from "../../styles/ComponentStyles";

export default function PasswordSettings({ onBack, user }) {
  const { translate } = useTranslate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });

  useEffect(() => {
    if (!message.text) return;
    const timer = setTimeout(() => setMessage({ text: "", type: "" }), 2500);
    return () => clearTimeout(timer);
  }, [message]);

  const handlePasswordUpdate = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      setMessage({ text: translate("all_fields_required"), type: "error" });
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage({ text: translate("passwords_do_not_match"), type: "error" });
      return;
    }

    try {
      const res = await updatePassword(user.user_id, oldPassword, newPassword);
      if (res?.success) {
        setMessage({ text: translate("password_updated"), type: "success" });
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setMessage({ text: translate("password_update_failed"), type: "error" });
      }
    } catch {
      setMessage({ text: translate("server_error"), type: "error" });
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton onClick={onBack}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {translate("update_password")}
        </Typography>
      </Box>

      <TextField
        type="password"
        label={translate("current_password")}
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
        fullWidth
      />
      <TextField
        type="password"
        label={translate("new_password")}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        fullWidth
      />
      <TextField
        type="password"
        label={translate("confirm_password")}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
      />

      {message.text && (
        <Typography
          variant="body2"
          sx={{
            color: message.type === "success" ? "green" : "red",
            mt: 1,
            textAlign: "center",
            fontWeight: 500,
          }}
        >
          {message.text}
        </Typography>
      )}

      <Box display="flex" justifyContent="flex-end" gap={1} mt={1}>
        <Button
          fullWidth
          variant="contained"
          sx={buttonPrimaryStyles}
          onClick={handlePasswordUpdate}
        >
          {translate("save")}
        </Button>
      </Box>
    </>
  );
}
